import React from 'react';
import Marquee from 'react-marquee-slider';

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

type DataEdges = {
  node: {
    id: string;
    base: string;
    childImageSharp: {
      gatsbyImageData: IGatsbyImageData;
    };
  };
};

const ClinicMarquee = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(jpeg)|(svg)| /" }
          relativeDirectory: { eq: "clinicLogos" }
          base: { regex: "/(?:white.p)/" }
        }
      ) {
        edges {
          node {
            id
            base
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [WEBP, AVIF])
            }
          }
        }
      }
    }
  `);

  const images = data.allFile.edges as DataEdges[];

  return (
    <div className={classNames.container}>
      <div className={classNames.textContainer}>
        <h3 className={classNames.subtitle}>Built with clinics, for clinics</h3>
      </div>
      <div className={classNames.marqueeContainer}>
        <Marquee
          velocity={25}
          direction="rtl"
          scatterRandomly={false}
          resetAfterTries={0}
          onInit={function (): void {}}
          onFinish={() => {}}
        >
          {images.map((image, index) => {
            const img = image?.node?.childImageSharp?.gatsbyImageData;
            const alt = image.node.base.split('.')[0];
            return (
              <GatsbyImage
                key={index}
                className={classNames.img}
                objectFit="contain"
                image={img}
                alt={alt}
              />
            );
          })}
        </Marquee>
      </div>
    </div>
  );
};

const classNames = {
  container: [
    'tw-w-[100%]',
    'tw-flex',
    'tw-flex-col',
    'tw-py-[24px]',
    'md:tw-py-[40px]',
    'xl:tw-py-[80px]',
    'tw-bg-space',
  ].join(' '),
  textContainer: [
    'tw-text-center',
    'tw-mb-[16px]',
    'md:tw-mb-[32px]',
    'xl:tw-mb-[40px]',
  ].join(' '),
  subtitle: ['tw-subtitle', 'tw-text-dusk'].join(' '),
  marqueeContainer: ['tw-flex'].join(' '),
  img: [
    'tw-w-[calc((100vw-(8px*5))/4)]',
    'md:tw-w-[calc((100vw-(18px*6))/5)',
    'tw-max-h-[96px]',
  ].join(' '),
};

export { ClinicMarquee };
